module.exports = __webpack_public_path__ + "static/media/natilla-bunuelos.973868fb.webp";